<template>
  <FullscreenPanel>
    <span class="loadingText">
      <span>{{ frameCharacter }}</span>
      Fetching info
    </span>
  </FullscreenPanel>
</template>

<script>
import FullscreenPanel from './FullscreenPanel'

const TICK_INTERVAL = 80
const FRAMES = ['⠋', '⠙', '⠹', '⠸', '⠼', '⠴', '⠦', '⠧', '⠇', '⠏']

export default {
  components: { FullscreenPanel },
  data() {
    return { timer: null, currentFrame: 0 }
  },
  computed: {
    frameCharacter() {
      return FRAMES[this.currentFrame]
    }
  },
  mounted() {
    this.timer = setInterval(() => this.tick(), TICK_INTERVAL)
  },
  unmounted() {
    console.log('#unmounted')

    if (this.timer) clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    tick() {
      this.currentFrame = (this.currentFrame + 1) % FRAMES.length
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.loadingText {
  font-size: 8vmin;
  opacity: 0;

  animation: fade-in 500ms ease;
  animation-delay: 500ms;
  animation-fill-mode: forwards;
}
</style>
